import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import { getEventIconName } from '$features/monitoring/events/events.utils';

type StatusMessageProps = {
  status: string;
  text: string;
  prefix?: string;
};

export function StatusMessage({
  status,
  text,
  prefix,
}: StatusMessageProps): ReactElement {
  return (
    <div className="flex flex__ac--flex-start">
      <Icon
        name={`event-${getEventIconName(status)}`}
        size={IconSizeClasses.XSmall}
        className="m-right-s p-x-m"
      />
      <span className="p-top-xxs">
        {prefix && <span className="font-weight-bold">{prefix}</span>}
        <span>{text}</span>
      </span>
    </div>
  );
}
